import {
  FETCH_RESOURCE_CLEANUP_DETAILS,
  FETCH_RESOURCE_CLEANUP_DETAILS_SUCCESS,
  FETCH_RESOURCE_CLEANUP_DETAILS_FAILED,
  SET_SEARCH_RESOURCE_CLEANUP,
  FETCH_RESOURCE_FILE_DETAILS,
  FETCH_RESOURCE_FILE_DETAILS_FAILED,
  FETCH_RESOURCE_FILE_DETAILS_SUCCESS,
  SET_SEARCH_RESOURCE_FILE,
  VALIDATE_FILE,
  VALIDATE_FILE_SUCCESS,
  VALIDATE_FILE_FAILED,
  PROCESS_CLEANUP,
  PROCESS_CLEANUP_SUCCESS,
  PROCESS_CLEANUP_FAILED,
  UPDATE_PROCESS_CLEANUP_RESPONSE,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAILED,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILED,
} from './resources-action';
import { DEFAULT_GRID_SIZE } from '@med-fe/util';

export const RESOURCE_CLEANUP_STATE_KEY = 'RESOURCE_CLEANUP_REDUCER';
export const RESOURCE_FILE_STATE_KEY = 'RESOURCE_FILE_REDUCER';

export const defaultSearchAudit = {
  page: 0,
  size: DEFAULT_GRID_SIZE,
};

const defaultState = {
  loading: false,
  resource: [],
  error: null,
  search: defaultSearchAudit,
  processStatus: false,
};
export const getResources = (state: any) => state[RESOURCE_CLEANUP_STATE_KEY].resource;
export const getSearch = (state) => state[RESOURCE_CLEANUP_STATE_KEY].search;
export const getSorting = (state) => state[RESOURCE_CLEANUP_STATE_KEY].sorting;
export const getTotal = (state) => state[RESOURCE_CLEANUP_STATE_KEY]?.resource.length || 0;
export const getLoading = (state) => state[RESOURCE_CLEANUP_STATE_KEY].loading;
export const getProcessStatus = (state) => state[RESOURCE_CLEANUP_STATE_KEY].processStatus;

export const getResourcesForGrid = (state) =>
  getResources(state).map((item: any) => ({
    ...item,
    key: item.id,
  }));

export const resourceCleanupReducer = (state = defaultState, { type, payload }: any) => {
  switch (type) {
    case FETCH_RESOURCE_CLEANUP_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RESOURCE_CLEANUP_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        resource: payload,
        processStatus: payload.findIndex((e) => e.processedOn == null) == -1,
      };
    case FETCH_RESOURCE_CLEANUP_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case SET_SEARCH_RESOURCE_CLEANUP:
      return {
        ...state,
        // search: { ...state.search, ...payload },
      };
    default:
      return state;
  }
};

export const getResourcesFile = (state: any) => state[RESOURCE_FILE_STATE_KEY].resource;
export const getSearchFile = (state) => state[RESOURCE_FILE_STATE_KEY].search;
export const getSortingFile = (state) => state[RESOURCE_FILE_STATE_KEY].sorting;
export const getTotalFile = (state) => state[RESOURCE_FILE_STATE_KEY].total;
export const getLoadingFile = (state) => state[RESOURCE_FILE_STATE_KEY].loading;

export const getResourcesFromFile = (state) =>
  getResourcesFile(state).map((item: any) => ({
    ...item,
  }));

const defaultFileState = {
  loading: false,
  resource: [],
  error: null,
  search: defaultSearchAudit,
};

export const resourceFileReducer = (state = defaultFileState, { type, payload }: any) => {
  switch (type) {
    case FETCH_RESOURCE_FILE_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RESOURCE_FILE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        resource: payload,
      };
    case FETCH_RESOURCE_FILE_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case SET_SEARCH_RESOURCE_FILE:
      return {
        ...state,
        search: { ...state.search, ...payload },
      };
    default:
      return state;
  }
};

export const VALIDATE_FILE_KEY = 'VALIDATE_FILE';

export const getValidateFileLoading = (state: any) => state[VALIDATE_FILE_KEY].loading;

export interface ValidateState {
  loading: boolean;
}

const validateDefaultState: ValidateState = {
  loading: false,
};

export const validateReducer = (state = validateDefaultState, { type }: any) => {
  switch (type) {
    case VALIDATE_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case VALIDATE_FILE_FAILED:
    case VALIDATE_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export const PROCESS_CLEANUP_KEY = 'PROCESS_CLEANUP';

export const getProcessResourceLoading = (state: any) => state[PROCESS_CLEANUP_KEY].loading;
export const getProcessCleanupResponse = (state: any) => state[PROCESS_CLEANUP_KEY].processResponse;

export interface ProcessState {
  loading: boolean;
  processResponse: any;
}

const processDefaultState: ProcessState = {
  loading: false,
  processResponse: null,
};

export const processCleanupReducer = (state = processDefaultState, { type, payload }: any) => {
  switch (type) {
    case PROCESS_CLEANUP: {
      return {
        ...state,
        loading: true,
      };
    }
    case PROCESS_CLEANUP_FAILED:
    case PROCESS_CLEANUP_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case UPDATE_PROCESS_CLEANUP_RESPONSE: {
      return {
        ...state,
        loading: false,
        processResponse: payload,
      };
    }
    default:
      return state;
  }
};

export const DOWNLOAD_FILE_KEY = 'DOWNLOAD_FILE';

export const getDownloadFileLoading = (state: any) => state[VALIDATE_FILE_KEY].loading;

export interface DownloadState {
  loading: boolean;
}

const downloadDefaultState: DownloadState = {
  loading: false,
};

export const downloadReducer = (state = downloadDefaultState, { type }: any) => {
  switch (type) {
    case DOWNLOAD_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DOWNLOAD_FILE_FAILED:
    case DOWNLOAD_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export const DELETE_FILE_KEY = 'DELETE_FILE';

export const getDeleteFileLoading = (state: any) => state[VALIDATE_FILE_KEY].loading;

export interface DeleteState {
  loading: boolean;
}

const deleteDefaultState: DeleteState = {
  loading: false,
};

export const deleteReducer = (state = deleteDefaultState, { type }: any) => {
  switch (type) {
    case DELETE_FILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DELETE_FILE_FAILED:
    case DELETE_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};
